// @flow

// Country polygons
import allcountries from '../../../static/allcountries.json'
import mexico from '../../../static/mexico.json'
import venezuela from '../../../static/venezuela.json'
import mali from '../../../static/mali.json'
import yemen from '../../../static/yemen.json'
import myanmar from '../../../static/myanmar.json'
import iraq from '../../../static/iraq.json'
import syria from '../../../static/syria.json'
import afghanistan from '../../../static/afghanistan.json'
import korea from '../../../static/korea.json'
import russland from '../../../static/russland.json'
import israel from '../../../static/israel.json'
import africa from '../../../static/africa.json'
import kinahavet from '../../../static/kinahavet.json'

export type Chapter = {
  title: string,
  text: string,
  fallbackPicture: {
    horizontalId: string,
    verticalId: string
  },
  mapbox: any
}

export const chapters: Array<Chapter> = [
  {
    gdocId: 'oversikt',
    title: 'Verdens farligste steder',
    text: '',
    fallbackPicture: '1.14041223',
    mapbox: {
      id: 'allcountries',
      duration: 6000,
      center: [20.067738, 20.236030],
      zoom: 2,
      pitch: 0,
      bearing: 0,
      mapColor: 'dark',
      multiPolygon: { name: 'allcountries', data: allcountries }
    }
  }, {
    gdocId: 'venezuela',
    title: 'Venezuela',
    text: '',
    fallbackPicture: '1.14041312',
    textAlign: 'left',
    mapbox: {
      id: 'venezuela',
      duration: 16000,
      center: [-66.168934, 7.076824],
      bearing: 0,
      zoom: 3,
      pitch: 0,
      polygon: { name: 'venezuela', data: venezuela },
      label: {
        data: {
          'type': 'Feature',
          'geometry': {
            'type': 'Point',
            'coordinates': [-66.056514, 7.055645]
          },
          'properties': {
            'name': 'Venezuela'
          }
        }
      }
    }
  }, {
    gdocId: 'mexico',
    title: 'Mexico',
    text: '',
    fallbackPicture: '1.14041315',
    textAlign: 'right',
    mapbox: {
      id: 'mexico',
      duration: 6000,
      center: [-101.722711, 23.964423],
      bearing: 0,
      zoom: 3,
      pitch: 0,
      polygon: { name: 'mexico', data: mexico },
      label: {
        data: {
          'type': 'Feature',
          'geometry': {
            'type': 'Point',
            'coordinates': [-102.540914, 23.992439]
          },
          'properties': {
            'name': 'Mexico'
          }
        }
      }
    }
  }, {
    gdocId: 'korea',
    title: 'Korea-halvøya og Guam',
    text: '',
    fallbackPicture: '1.14041318',
    textAlign: 'left',
    mapbox: {
      id: 'korea',
      duration: 6000,
      center: [132.694545, 30.860704],
      bearing: 0,
      zoom: 4,
      pitch: 0,
      mapColor: 'red',
      multiPolygon: { name: 'korea', data: korea },
      label: {
        data: {
          'type': 'Feature',
          'geometry': {
            'type': 'Point',
            'coordinates': [127.114964, 38.349430]
          },
          'properties': {
            'name': 'Korea-halvøya'
          }
        }
      }
    }
  }, {
    gdocId: 'sorkinahavet',
    title: 'Sør-Kina havet',
    text: '',
    fallbackPicture: '1.14041320',
    textAlign: 'left',
    mapbox: {
      id: 'sorkinahavet',
      duration: 6000,
      center: [113.850947, 12.622392],
      bearing: 0,
      zoom: 4,
      pitch: 0,
      mapColor: 'pattern',
      polygon: { name: 'kinahavet', data: kinahavet },
      label: {
        data: {
          'type': 'Feature',
          'geometry': {
            'type': 'Point',
            'coordinates': [113.850947, 12.622392]
          },
          'properties': {
            'name': 'Sør-Kinahavet'
          }
        }
      }
    }
  }, {
    gdocId: 'myanmar',
    title: 'Myanmar',
    text: '',
    fallbackPicture: '1.14041323',
    textAlign: 'right',
    mapbox: {
      id: 'myanmar',
      duration: 6000,
      center: [96.426326, 21.687312],
      bearing: 0,
      zoom: 4,
      pitch: 0,
      polygon: { name: 'myanmar', data: myanmar },
      label: {
        data: {
          'type': 'Feature',
          'geometry': {
            'type': 'Point',
            'coordinates': [96.332217, 21.522439]
          },
          'properties': {
            'name': 'Myanmar'
          }
        }
      }
    }
  }, {
    gdocId: 'afghanistan',
    title: 'Afghanistan',
    text: '',
    fallbackPicture: '1.14041324',
    textAlign: 'right',
    mapbox: {
      id: 'afghanistan',
      duration: 6000,
      center: [64.989179, 33.826518],
      bearing: 0,
      zoom: 4,
      pitch: 0,
      polygon: { name: 'afghanistan', data: afghanistan },
      label: {
        data: {
          'type': 'Feature',
          'geometry': {
            'type': 'Point',
            'coordinates': [64.955479, 33.831614]
          },
          'properties': {
            'name': 'Afghanistan'
          }
        }
      }
    }
  }, {
    gdocId: 'jemen',
    title: 'Jemen',
    text: '',
    fallbackPicture: '1.14041331',
    textAlign: 'left',
    mapbox: {
      id: 'yemen',
      duration: 6000,
      center: [47.500638, 15.819084],
      bearing: 0,
      zoom: 4,
      pitch: 0,
      polygon: { name: 'yemen', data: yemen },
      label: {
        data: {
          'type': 'Feature',
          'geometry': {
            'type': 'Point',
            'coordinates': [47.642982, 15.831732]
          },
          'properties': {
            'name': 'Jemen'
          }
        }
      }
    }
  }, {
    gdocId: 'irak',
    title: 'Irak',
    text: '',
    fallbackPicture: '1.14041335',
    textAlign: 'left',
    mapbox: {
      id: 'iraq',
      duration: 6000,
      center: [43.053128, 33.035173],
      bearing: 0,
      zoom: 4,
      pitch: 0,
      polygon: { name: 'iraq', data: iraq },
      label: {
        data: {
          'type': 'Feature',
          'geometry': {
            'type': 'Point',
            'coordinates': [43.064757, 33.025970]
          },
          'properties': {
            'name': 'Irak'
          }
        }
      }
    }
  }, {
    gdocId: 'syria',
    title: 'Syria',
    text: '',
    fallbackPicture: '1.14041338',
    textAlign: 'right',
    mapbox: {
      id: 'syria',
      duration: 6000,
      center: [38.473191, 34.992579],
      bearing: 0,
      zoom: 4,
      pitch: 0,
      polygon: { name: 'syria', data: syria },
      label: {
        data: {
          'type': 'Feature',
          'geometry': {
            'type': 'Point',
            'coordinates': [38.474830, 34.989984]
          },
          'properties': {
            'name': 'Syria'
          }
        }
      }
    }
  }, {
    gdocId: 'midtoesten',
    title: 'Israel, Palestina og Lebanon',
    text: '',
    fallbackPicture: '1.14041342',
    textAlign: 'left',
    mapbox: {
      id: 'israel',
      duration: 6000,
      center: [35.480960, 32.647645],
      bearing: 0,
      zoom: 5,
      pitch: 0,
      mapColor: 'red',
      multiPolygon: { name: 'israel', data: israel },
      label: {
        data: {
          'type': 'Feature',
          'geometry': {
            'type': 'Point',
            'coordinates': [35.480960, 32.647645]
          },
          'properties': {
            'name': 'Midtøsten'
          }
        }
      }
    }
  }, {
    gdocId: 'russland',
    title: 'Russland',
    text: '',
    fallbackPicture: '1.14041345',
    textAlign: 'left',
    mapbox: {
      id: 'russland',
      duration: 6000,
      center: [33.033418, 52.600242],
      bearing: 0,
      zoom: 3,
      pitch: 0,
      mapColor: 'red',
      polygon: { name: 'russland', data: russland },
      label: {
        data: {
          'type': 'Feature',
          'geometry': {
            'type': 'Point',
            'coordinates': [98.020540, 62.221022]
          },
          'properties': {
            'name': 'Russland'
          }
        }
      }
    }
  }, {
    gdocId: 'mali',
    title: 'Mali',
    text: '',
    fallbackPicture: '1.14041349',
    textAlign: 'left',
    mapbox: {
      id: 'mali',
      duration: 6000,
      center: [-1.631458, 17.830773],
      bearing: 0,
      zoom: 4,
      pitch: 0,
      polygon: { name: 'mali', data: mali },
      label: {
        data: {
          'type': 'Feature',
          'geometry': {
            'type': 'Point',
            'coordinates': [-1.776001, 17.795957]
          },
          'properties': {
            'name': 'Mali'
          }
        }
      }
    }
  }, {
    gdocId: 'afrika',
    title: 'Konflikter i Afrika',
    text: '',
    fallbackPicture: '1.14053937',
    textAlign: 'left',
    mapbox: {
      id: 'africa',
      duration: 6000,
      center: [20.158840, 6.583133],
      bearing: 0,
      zoom: 3,
      pitch: 0,
      mapColor: 'red',
      multiPolygon: { name: 'africa', data: africa },
      labels: [
        {
          data: {
            'type': 'Feature',
            'geometry': {
              'type': 'Point',
              'coordinates': [19.646473, 6.748540]
            },
            'properties': {
              'name': 'Den sentralafrikanske republikk'
            }
          }
        },
        {
          data: {
            'type': 'Feature',
            'geometry': {
              'type': 'Point',
              'coordinates': [30.193348, 7.206547]
            },
            'properties': {
              'name': 'Sør-Sudan'
            }
          }
        },
        {
          data: {
            'type': 'Feature',
            'geometry': {
              'type': 'Point',
              'coordinates': [23.667469, -3.670301]
            },
            'properties': {
              'name': 'DR Kongo'
            }
          }
        },
        {
          data: {
            'type': 'Feature',
            'geometry': {
              'type': 'Point',
              'coordinates': [46.950330, 5.733050]
            },
            'properties': {
              'name': 'Somalia'
            }
          }
        }]
    }
  }, {
    gdocId: 'outtro',
    title: 'Avslutning',
    text: '',
    fallbackPicture: '1.14041356',
    textAlign: 'left',
    mapbox: {
      id: 'avslutning',
      duration: 6000,
      center: [20.158840, 6.583133],
      bearing: 0,
      zoom: 2,
      pitch: 0,
      mapColor: 'red',
      label: {
        data: {
          'type': 'Feature',
          'geometry': {
            'type': 'Point',
            'coordinates': [20.158840, 6.583133]
          },
          'properties': {
            'name': ''
          }
        }
      }
    }
  }
]

export function createChapters (doc: DocType): Array<Chapter> {
  return chapters.map(chapter => {
    const gdoc = doc[chapter.gdocId] || {}
    return { ...chapter, ...gdoc }
  })
}



// WEBPACK FOOTER //
// ./src/v1/components/chapters.js